import Image from 'next/image'

export default function MiniCallouts({ callouts }) {
	return (
		<div className="c-mini-callouts">
			<div className="g-grid-container">
				<ul>
					{callouts.map((callout) => {
						return (
							<li key={callout.image.url}>
								<Image
									src={callout.image.url}
									alt={callout.image.alt}
									width={callout.image.width}
									height={callout.image.height}
								/>
								<div className="text">
									<strong>{callout.title}</strong>
									<p>{callout.description}</p>
								</div>
							</li>
						)
					})}
				</ul>
			</div>
		</div>
	)
}
